import { useEffect, useState } from "react";
import { History } from "lucide-react";
import { AdminLayout } from "@/components/AdminLayout";
import { api } from "@/lib/api";

const ACTION_LABELS = {
  login: "Inicio de sesión",
  export_company_data: "Exportación completa de datos",
  create_employee: "Alta de empleado",
  change_compensation: "Cambio de salario",
  terminate_employee: "Baja de empleado",
};

export default function AuditLog() {
  const [events, setEvents] = useState(null);

  useEffect(() => {
    api.get("/audit-log").then(({ data }) => setEvents(data));
  }, []);

  return (
    <AdminLayout>
      <div className="max-w-2xl">
        <h1 className="font-heading text-3xl font-bold text-charcoal tracking-tight flex items-center gap-3">
          <History className="w-7 h-7 text-petroleum" strokeWidth={1.5} /> Bitácora de seguridad
        </h1>
        <p className="text-charcoal/60 mt-1 mb-6">
          Inicios de sesión, exportaciones de datos, altas de empleados, cambios de salario y bajas.
          Se sigue ampliando con más acciones registradas.
        </p>

        <div className="space-y-2">
          {events === null && <p className="text-sm text-charcoal/50">Cargando…</p>}
          {events?.length === 0 && <p className="text-sm text-charcoal/50">Todavía no hay eventos registrados.</p>}
          {events?.map((e) => (
            <div key={e.id} className="bg-card border border-petroleum/10 rounded-xl p-4 flex items-center justify-between gap-3">
              <div>
                <p className="text-sm font-semibold text-charcoal">{ACTION_LABELS[e.action] || e.action}</p>
                <p className="text-xs text-charcoal/50 mt-0.5">
                  {e.actor_name || "Desconocido"} ({e.actor_role})
                  {e.detail?.full_name ? ` · sobre ${e.detail.full_name}` : ""}
                </p>
              </div>
              <p className="text-xs text-charcoal/50 shrink-0">{new Date(e.timestamp).toLocaleString("es-MX")}</p>
            </div>
          ))}
        </div>
      </div>
    </AdminLayout>
  );
}
